export const headerHeight = 100;
export const mobileHeaderHeight = 60;
export const footerMinHeight = 125;
export const contentMaxWidth = 1000;
